module.exports = __webpack_public_path__ + "app/images/services/codingImage2.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/services/codingImage2.png
// module id = 443
// module chunks = 0